﻿const history = window.History;

function buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data,
        function (value, key) {
            if (key === "isPageChange")
                return;
            if (value) {
                queryStringData[key] = value;
            }
        });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}

function getData() {
    const dataArray = $("[data-what-is-my-car-mpg-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function (item) {
        if (data[item.name]) {
            if (typeof (data[item.name]) === "string") {
                data[item.name] = [data[item.name]];
            }
            data[item.name].push(item.value);
        } else {
            data[item.name] = item.value;
        }
    });
    return data;
}

function updateResultsLogic(isPageChange) {
    const data = getData();
    if (isPageChange) {
        data.isPageChange = true;
    }
    history.pushState(data, $("title").html(), location.pathname + "?" + buildUpQueryString(data));
    return data;
}


function triggerUpdateResults(event) {
    if ($(event.target).data("autocomplete") != null)
        return;

    if (event.target.name === "ManufacturerId") {
        if ($("#ModelGroupId").val() != null) {
            $("#ModelGroupId").val("");
            $("#DerivativeId").val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if ($("#DerivativeId").val() != null) {
            $("#DerivativeId").val("");
        }
    }
    window.updateResults();
}

function reloadQuery() {
    const state = history.getState();
    $.get('/costs/what-is-my-car-mpg/query', state.data, function (response) {
        $('[data-what-is-my-car-mpg-query-attributes]').replaceWith(response);
    });
}

function updateState() { // Note: We are using statechange instead of popstate
    reloadQuery();
    const state = history.getState();
    $.get('/costs/what-is-my-car-mpg/results', state.data, function (response) {
        $('[data-what-is-my-car-mpg-results-container]').replaceWith(response);

    });
}

function scrollToResult(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $(window).scrollTop() + 200
    }, 2000);

}

export function setupWhatIsMyCarMPG() {
    if (!$('[data-what-is-my-car-mpg]').length) {
        return;
    }
    $(document)
        .on("change",
            "[data-what-is-my-car-mpg-query-attributes] input, [data-what-is-my-car-mpg-query-attributes] select",
            triggerUpdateResults);
    $(document).on("click", "[data-view-result-button]", scrollToResult);
    //Bind to StateChange Event
    history.Adapter.bind(window, "statechange", updateState);
    
    window.updateResults = function () {
        updateResultsLogic();
    };
}